import React from 'react';
import { DictPicker } from '../../dict/simple/select/DictPicker.jsx';
import { connect } from 'react-redux';
import { getUsersSelectWrapper } from './UserWrapper.js';
import { handleFormChanged } from '@/store/allaround.store.js';
import { List } from 'immutable';

class UserPicker extends React.Component {
  componentWillMount() {
    getUsersSelectWrapper();
  }
  componentWillReceiveProps() {
    getUsersSelectWrapper();
  }
  render() {
    let component;
    if (this.props.data) {
      component = (<DictPicker
        noAddButton
        {...this.props}
      />);
    } else {
      component = <div></div>;
    }
    return component;
  }
}
UserPicker.propTypes = {
  data: React.PropTypes.array,
  name: React.PropTypes.string,
  onChangeFunc: React.PropTypes.func,
  defaultValue: React.PropTypes.oneOfType(
    [
      React.PropTypes.object,
      React.PropTypes.array,
      React.PropTypes.number,
    ]
  ),
  handleFormChanged: React.PropTypes.func,
  productsSelected: React.PropTypes.array,
};


export default connect((state) => ({
  data: state.getIn(['data', 'users_select'], new List())
    .toJS()
    .map((elem) => ({ value: elem.id, label: elem.fullname })),
  isChanged: state.getIn(['allaround', 'formChanged'], false),
}),
(dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(UserPicker);
